import { create } from "zustand";

/**
 * useIndicadoresServicosFilters
 */

export type IndicadoresServicosState = {
  area: string | null;
  atividades: number[] | null;
  status: number | null;
};

export const initialIndicadoresServicosState: IndicadoresServicosState = {
  area: null,
  atividades: null,
  status: 0,
};

export const useIndicadoresServicosFilters = create<IndicadoresServicosState>(set => ({
  ...initialIndicadoresServicosState,
}));